import styled from 'styled-components';
import { Chip } from '@material-ui/core';
import { SHORTCUT_ENTITIES_TYPES } from 'common/constants/constants';
import Icon from 'components/base/Icon';
import { SPACES } from 'common/constants/sizes';

const ChipEntityTypeStyled = styled(Chip)`
  margin-left: ${SPACES['x-small']};
  &.MuiChip-root {
    padding: 0.5rem 0.2rem;
    & .MuiChip-icon {
      height: 100%;
      width: 100%;
    }
  }
`;

const mapEntityTypeToUiProps = {
  [SHORTCUT_ENTITIES_TYPES.PROJECT]: {
    label: 'PROJECT',
    icon: () => <Icon name='ShortcutLogo' />
  },
  [SHORTCUT_ENTITIES_TYPES.TEAM]: {
    label: 'TEAM',
    icon: () => <Icon name='ShortcutLogo' />
  }
};

const ChipEntityType = ({ entityType }) => {
  const uiProps = mapEntityTypeToUiProps[entityType];
  if (!uiProps) return null;

  const { label, icon } = uiProps;
  return (
    <ChipEntityTypeStyled
      variant='outlined'
      size='small'
      label={label}
      icon={icon()}
    />
  );
};

export default ChipEntityType;
